module.exports = __webpack_public_path__ + "img/Fiche responsable d'équipe communication.67177724.jpg";